<section appTitle pageTitle="Tags">
    <app-single-tag (update)="updateTag($event)" (delete)="deleteTag($event)" *ngFor="let tag of tag$ | async" [tag]="tag"></app-single-tag>
    <div>

        <svg class="cms-button-text-primary" (click)="add()" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 211.97 211.97"><defs><style>.cls-1{fill:#85CDDB;}.cls-2{fill:#fff;}</style></defs><title>addicon</title><g id="Ebene_2" data-name="Ebene 2"><g id="Background"><circle class="cls-1" cx="105.99" cy="105.99" r="105.99"/><path class="cls-2" d="M68.52,101.61h32.92v-33h9.09v33h32.92v9H110.53v32.71h-9.09V110.64H68.52Z"/>
        </g></g>
        </svg>
    </div>
</section>
